<!--
 * @Author: Haotao
 * @Date: 2022-10-13 13:06:22-29 10:39:21
 * @LastEditors: Haotao
 -->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>


<script>

export default {
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {
  }

}
</script>
<style lang='less' scoped>
</style>
